<template>
  <section class="page-contact">
    <div class="page-contact__wrapper">
      <div class="page-contact__form">
        <div class="page-contact__headline">Contact-Form</div>
        <p class="page-contact__subtitle">Get in touch with us!</p>
        <div class="page-contact__inputs">
          <div class="page-contact__row">
            <input type="text" placeholder="Your name" />
            <input type="email" placeholder="Your email" />
          </div>
          <div class="page-contact__row">
            <input type="text" placeholder="Phone" />
          </div>
          <div class="page-contact__row">
            <textarea rows="4" placeholder="Your message"></textarea>
          </div>
          <button class="page-contact__button">Send</button>
        </div>
      </div>
      <div class="page-contact__info">
        <div class="page-contact__headline">General Information</div>
        <p class="page-contact__subtitle">Thomas und Eva Buchwald</p>
        <p class="page-contact__contact-data">
          <fa-icon :icon="['fa', 'mobile-alt']" size="xs" />
          Eva: (+49) 176 2276 9157
        </p>
        <p class="page-contact__contact-data">
          <fa-icon :icon="['fa', 'mobile-alt']" size="xs" />
          Thomas: (+49) 176 3046 8196
        </p>
        <p class="page-contact__contact-data">
          <fa-icon :icon="['fa', 'at']" size="xs" /> Email:
          info@vintage-and-art.com
        </p>
        <p class="page-contact__contact-data">
          <fa-icon :icon="['fa', 'map-marker-alt']" size="xs" />
          Address: Kieselborn 17, 66280 Sulzbach/Saar'
        </p>
      </div>
    </div>
  </section>
</template>
<script>
export default {}
</script>
<style lang="sass">

$input-bg: #2e2e2e

.page-contact
    &__wrapper
        @apply flex flex-col w-full px-4
    &__form
        @apply
    &__info, &__form
        @apply text-white
    &__info
        @apply mb-8
    &__headline
        @apply text-4xl
    &__subtitle
        @apply text-2xl
    &__contact-data
        @apply text-xl
    &__row input, &__row textarea
        background: $input-bg
        min-height: 45px
        @apply my-2 w-full rounded-md text-white px-2 text-xl
    &__button
        background: $accent-color
        @apply w-full rounded-md mb-4

@screen md
    .page-contact
        &__wrapper
            @apply flex-row
        &__info, &__form
            @apply w-1/2 px-4
        &__info
            @apply text-center flex flex-col justify-center items-center
        &__button
            @apply w-1/4
</style>
